function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#1E2F7B",
  fillRule: "evenodd",
  d: "M12 5.25c-4.414 0-8.235 2.768-9.636 6.594a.3.3 0 0 0 0 .312C3.765 15.983 7.586 18.75 12 18.75s8.235-2.768 9.636-6.594a.3.3 0 0 0 0-.312C20.235 8.017 16.414 5.25 12 5.25M.25 11.07C1.98 6.348 6.65 3 12 3c5.35 0 10.02 3.348 11.75 8.07.22.6.22 1.26 0 1.86C22.02 17.652 17.35 21 12 21 6.65 21 1.98 17.652.25 12.93a2.7 2.7 0 0 1 0-1.86M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0",
  clipRule: "evenodd"
});

function SvgViewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.5cd852b750209e8caec921d2b26be96a.svg";
export { ForwardRef as ReactComponent };